import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const sendGiftWrapper: CSSProperties = {
  marginTop: 20,
  marginBottom: 20
};

export const sendGiftContainer: CSSProperties = {
  backgroundColor: UIConfig.Card.Content.background,
  padding: 20,
  borderRadius: 12,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  alignItems: 'center'
};

export const sendGiftTextWrapper: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  width: '60%',
  height: '100%'
};

export const animationContainer: CSSProperties = {
  width: '40%',
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  position: 'relative',
  overflow: 'hidden'
};

export const animationWrapper: CSSProperties = {
  position: 'absolute',
  top: 'calc(50% - 135px)',
  left: 'calc(50% - 116px)',
  zIndex: 1
};

export const sendGiftTitle: CSSProperties = {
  color: 'white',
  fontSize: 17,
  fontWeight: 600,
  marginBottom: 15,
  textAlign: 'left',
  lineHeight: '21px'
};

export const sendGiftButton: CSSProperties = {
  alignSelf: 'flex-start',
  background: '#FFF',
  color: '#000',
  fontSize: 14,
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderRadius: '20px',
  padding: '10px 20px'
};

export const iconContainer: CSSProperties = {
  zIndex: 2,
  width: '74px',
  height: '74px',
  background: UIConfig.Colors.PrimaryGradient,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  marginRight: '10px'
};

export const infoBlockWrapper: CSSProperties = {
  backgroundColor: UIConfig.Card.Content.background,
  borderRadius: '12px',
  fontSize: '14px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  whiteSpace: 'pre-wrap',
  gap: '18px'
};

export const tagStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  backgroundColor: '#3a3a3a',
  borderRadius: '999px',
  padding: '8px 14px',
  color: '#fff',
  fontWeight: 600,
  fontSize: '15px',
  lineHeight: 1
};
